import { useTranslation, useUserSettings } from "@next-platform/client-common-core";

import ConfirmationModal from "./ConfirmationModal";

interface IBlockCreatorModalProps {
  creatorId: string;
  creatorUsername: string;
  isVisible: boolean;
  onClose: (visible: boolean) => void;
  onSuccess?: () => void;
  dataTestId?: string;
}

export const BlockCreatorModal = ({ creatorId, creatorUsername, isVisible, onClose, onSuccess, dataTestId = "" }: IBlockCreatorModalProps) => {
  const { t } = useTranslation();
  const { onUserBlockCreator, isLoading: isBlockLoading } = useUserSettings();
  const handleBlockCreator = async () => {
    if (creatorId) {
      await onUserBlockCreator(creatorId);
      onClose(false);
      onSuccess?.();
    }
  };

  return (
    <ConfirmationModal
      dataTestId={dataTestId}
      heading={t("creator:block.modal.title")}
      handleClose={() => onClose(false)}
      onUserConfirmation={handleBlockCreator}
      confirmationMessage={t("creator:block.modal.description", { creatorUsername })}
      isVisible={isVisible}
      isLoading={isBlockLoading}
      actionButtonColor="error"
      actionButtonText={t("creator:block.modal.cta.block")}
      discardButtonText={t("common:cancel")}
    />
  );
};
